<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-input-search
        placeholder="请输入搜索内容"
        style="width:225px;float:right;margin-top:19px;"
        @search="onSearch"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a @click="() => handleLook(record)">查看</a>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { columns } from './data/index';
export default {
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      keyWord: '',
    };
  },
  mounted() {
    // 判断是企业登录还是服务商
    let role = localStorage.getItem('role');
    this.url = '/Company/getCooperationCompanyList';
    // 获取表格数据
    this.getTableData({
      page: String(this.current),
      pageSize: String(this.pageSize),
      keyword: this.keyWord,
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(this.url, params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            qichacha_name: item.companyInfo.qichacha_name,
            qichacha_credit_code: item.companyInfo.qichacha_credit_code,
            qichacha_oper_name: item.companyInfo.qichacha_oper_name,
            qichacha_status: item.companyInfo.qichacha_status,
            qichacha_start_date: this.$Format(item.create_time)
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 搜索
    onSearch(value) {
      this.keyWord = value;
      this.current=1;
      this.getTableData({
        keyword: this.keyWord,
        page: this.current,
        pageSize: String(this.pageSize),
      });
    },
    // 查看
    handleLook(record) {
      this.$router.push({
        path: '/cooperation/details',
        query: { id: record.id },
      });
    },
    // 取消编辑或新增
    onCancel() {
      this.$router.back();
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        keyword: this.keyWord,
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
  },
};
</script>
<style lang="scss">
.client-container {
  .ant-input-search {
    .ant-input {
      border-radius: 20px;
    }
  }
}
</style>
